// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Calendrier from './calendrier/Calendrier';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import MembersPage from './pages/MembersPage';
import ActivityPage from './pages/ActivityPage';
import StatistiquesPage from './pages/StatistiquesPage'; // ✅ Import ajouté
import MainLayout from './layout/MainLayout';

const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes publiques */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Routes protégées avec layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Calendrier />} />
          <Route path="profil" element={<ProfilePage />} />
          <Route path="membres" element={<MembersPage />} />
          <Route path="activity/:userId" element={<ActivityPage />} />
          <Route path="statistiques" element={<StatistiquesPage />} /> {/* ✅ Route ajoutée */}
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;